export default {
  serviceList: [],
  phoneList: {
    primaryPhone: '',
    recentPhones: [],
  },
}



// WEBPACK FOOTER //
// ./src/store/hail/state.js